/**
 * @generated SignedSource<<25df64f8d060bd58e52cc0b3c498fc09>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type UpdateSongTags_tags$data = {
  readonly songs: {
    readonly __id: string;
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly tags: ReadonlyArray<string>;
      } | null;
    } | null> | null;
  };
  readonly " $fragmentType": "UpdateSongTags_tags";
};
export type UpdateSongTags_tags$key = {
  readonly " $data"?: UpdateSongTags_tags$data;
  readonly " $fragmentSpreads": FragmentRefs<"UpdateSongTags_tags">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "UpdateSongTags_tags",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "UserSongsConnection",
      "kind": "LinkedField",
      "name": "songs",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "UserSongsEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "Song",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "tags",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "kind": "ClientExtension",
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "__id",
              "storageKey": null
            }
          ]
        }
      ],
      "storageKey": null
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "9e1079e6e07d6800b50baf70b4fae4e4";

export default node;
